<div class="dt" [class.has-inline-actions]="inlineRowActions && showActions">
    <!-- header -->
    <div class="ipm-dt-head my-3" *ngIf="title || subtitle || showExport">
        <div class="ipm-heading-section">
            <h2 class="ipm-heading" *ngIf="title">{{ title }}</h2>
            <p class="ipm-total-section" *ngIf="subtitle">{{ subtitle }}</p>
        </div>
        <div class="ipm-button-section">
            <!-- <div class="custom-form my-0">
                        <div class="custom-form-group my-0">
                            <p-dropdown name="beat_type" inputId="beat_type" autocomplete="off"
                                [autoDisplayFirst]="true" [className]="'ipm-dropdown'" [options]="sortByDate"
                                optionLabel="value">
                            </p-dropdown>
                        </div>
                    </div> -->
            <button class="btn btn-primary" *ngIf="showExport" (click)="exportCsv()">
                <i class="pi pi-download"></i>
                <span class="btn-label">Export CSV</span>
            </button>
        </div>
    </div>

    <!-- ============ DESKTOP TABLE ============ -->
    <div class="ipm-data-table" *ngIf="!mobileView">
        <p-table [value]="data" [rowHover]="true" styleClass="dt-p-table" [scrollable]="true" [scrollHeight]="scrollHeight" [rowTrackBy]="rowTrackBy">
            <ng-template pTemplate="header">
                <tr>
                    <th *ngFor="let col of desktopColumns; let first = first" [class.num]="isNumeric(col)"
                        pFrozenColumn [frozen]="first"
                        [pSortableColumn]="col.field" [pSortableColumnDisabled]="!isSortable(col)">
                        {{ col.header }}
                        <p-sortIcon *ngIf="isSortable(col)" [field]="col.field"></p-sortIcon>
                        <i *ngIf="col.info" class="pi pi-info-circle col-info-icon" role="button"
                            [title]="col.info.title || col.header" (click)="openInfoDialog(col, $event)"></i>
                    </th>
                    <th *ngIf="rowActions.length && showActions && !inlineRowActions" class="num" >Actions</th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-row let-i="rowIndex">
                <tr class="clickable-row" (click)="onRowClick(row)">
                    <td *ngFor="let col of desktopColumns; let first = first" [class.num]="isNumeric(col)" [class.strong]="col.strong" pFrozenColumn [frozen]="first">
                      <div class="cell-inner" [class.with-toggle]="first && toggleColumn">
                        <!-- status switch, shown ahead of the first cell's value -->
                        <span *ngIf="first && toggleColumn" class="toggle-cell" (click)="$event.stopPropagation()">
                            <p-inputSwitch [ngModel]="toggleState(toggleColumn, row)"
                                [ngModelOptions]="{ standalone: true }"
                                [disabled]="toggleDisabled(toggleColumn, row)"
                                (ngModelChange)="onToggle(toggleColumn, row, $event)">
                            </p-inputSwitch>
                        </span>
                        <ng-container [ngSwitch]="col.type">
                            <!-- avatar (cover_picture image + title + subtitle) -->
                            <div *ngSwitchCase="'avatar'" class="track-cell">
                                <img *ngIf="avatarImage(row) && !hasImgError(row)" [src]="avatarImage(row)"
                                    class="avatar" alt="" (error)="onImgError(row)" />
                                <div *ngIf="!avatarImage(row) || hasImgError(row)" class="avatar-fb"
                                    [style.background]="colorFor(i)">
                                    {{ initial(row) }}
                                </div>
                                <div>
                                    <div class="track-name">{{ avatarTitle(row) }}</div>
                                    <div class="track-sub" *ngIf="avatarSub(row)">{{ avatarSub(row) }}</div>
                                </div>
                            </div>

                            <!-- status badge -->
                            <span *ngSwitchCase="'status'" class="status" [ngClass]="statusClass(col, row)">{{
                                status(col, row).label }}
                            </span>

                            <!-- status toggle (running / paused) -->
                            <span *ngSwitchCase="'toggle'" class="toggle-cell" (click)="$event.stopPropagation()">
                                <p-inputSwitch [ngModel]="toggleState(col, row)"
                                    [ngModelOptions]="{ standalone: true }"
                                    [disabled]="toggleDisabled(col, row)"
                                    (ngModelChange)="onToggle(col, row, $event)">
                                </p-inputSwitch>
                                <span class="toggle-label" *ngIf="toggleLabel(col, row)">{{ toggleLabel(col, row) }}</span>
                            </span>

                            <!-- everything else -->
                            <ng-container *ngSwitchDefault>
                                {{ format(col, row) }}
                                <!-- optional inline action, e.g. edit daily budget -->
                                <i *ngIf="showCellAction(col, row)" class="cell-action" [ngClass]="col.cellAction!.icon"
                                    role="button" [title]="col.cellAction!.tooltip || ''"
                                    (click)="$event.stopPropagation(); col.cellAction!.onClick(row)"></i>
                            </ng-container>
                        </ng-container>
                      </div>

                        <!-- actions tucked under the first column, revealed on row hover -->
                        <div class="row-actions-inline" *ngIf="first && inlineRowActions && rowActions.length && showActions"
                            (click)="$event.stopPropagation()">
                            <button *ngFor="let a of visibleActions(row)" type="button" class="inline-action"
                                [class.del]="a.danger" [title]="a.tooltip || a.label || ''" (click)="a.onClick(row)">
                                <i [class]="a.icon"></i>
                                <span class="inline-action-label" *ngIf="a.label">{{ a.label }}</span>
                            </button>
                        </div>
                    </td>

                    <td *ngIf="rowActions.length && showActions && !inlineRowActions" class="num" (click)="$event.stopPropagation()">
                        <button pButton type="button" icon="pi pi-chevron-down"
                            class="p-button-text p-button-rounded chev" (click)="openMenu($event, row, menu)"></button>
                        <p-menu #menu [model]="menuModel" [popup]="true" appendTo="body"></p-menu>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>

    <!-- ============ MOBILE CARDS ============ -->
    <div class="dt-cards" *ngIf="mobileView">
        <div class="card clickable-row" *ngFor="let row of data; let i = index" [class.collapsed]="!isExpanded(row)"
            (click)="onRowClick(row)">
            <div class="card-head">
                <img *ngIf="avatarImage(row) && !hasImgError(row)" [src]="avatarImage(row)" class="avatar" alt=""
                    (error)="onImgError(row)" />
                <div *ngIf="!avatarImage(row) || hasImgError(row)" class="avatar-fb" [style.background]="colorFor(i)">
                    {{ initial(row) }}
                </div>
                <div class="meta">
                    <div class="card-title">{{ avatarTitle(row) }}</div>
                    <div class="card-sub" *ngIf="avatarSub(row)">{{ avatarSub(row) }}</div>
                </div>
                <span *ngIf="toggleColumn" class="toggle-cell" (click)="$event.stopPropagation()">
                    <p-inputSwitch [ngModel]="toggleState(toggleColumn, row)"
                        [ngModelOptions]="{ standalone: true }"
                        [disabled]="toggleDisabled(toggleColumn, row)"
                        (ngModelChange)="onToggle(toggleColumn, row, $event)">
                    </p-inputSwitch>
                </span>
                <span *ngIf="statusColumn" class="status" [ngClass]="statusClass(statusColumn, row)">{{
                    status(statusColumn, row).label }}</span>
            </div>

            <div class="divider top"></div>

            <!-- every metric carries its label in mobile view -->
            <div class="metrics">
                <div class="metric" *ngFor="let col of cardColumns">
                    <span class="label">
                        {{ col.header }}
                        <i *ngIf="col.info" class="pi pi-info-circle col-info-icon" role="button"
                            [title]="col.info.title || col.header" (click)="openInfoDialog(col, $event)"></i>
                    </span>
                    <span class="value">{{ format(col, row) }}</span>
                </div>
            </div>

            <div class="divider"></div>

            <div class="card-foot" (click)="$event.stopPropagation()">
                <button class="toggle-btn" (click)="toggle(row)">
                    <i class="pi pi-chevron-up chev-icon"></i>
                </button>
                <div class="icon-row" *ngIf="rowActions.length && showActions">
                    <button *ngFor="let a of visibleActions(row)" class="icon-btn" [class.del]="a.danger"
                        [pTooltip]="a.tooltip || ''" (click)="a.onClick(row)">
                        <i [class]="a.icon"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Shared info dialog for column headers (centred on desktop, bottom sheet on mobile) -->
<ng-template #infoPop let-data>
    <ipm-info-dialog [title]="data.title" [message]="data.message" [icon]="data.icon"></ipm-info-dialog>
</ng-template>